import { render, staticRenderFns } from "./AddScene.vue?vue&type=template&id=89811e7e&"
import script from "./AddScene.vue?vue&type=script&lang=js&"
export * from "./AddScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports